import { useStyledPhotoUploadFieldLazyQuery } from 'generated/graphql';

import {
  useCallback,
  useMemo
} from 'react';



export interface IData {
  fileName: string;
  sizeBytes: string;
  id: string;
  url: string;
  mimeType: string;
}

export function useQuery() {
  const [
    fnQuery,
    tuple
  ] = useStyledPhotoUploadFieldLazyQuery({
  });

  const fnWrappedQuery = useCallback(
    (apiFileId: string) => {
      fnQuery({
        variables: {
          apiFileId
        }
      });
    },
    [fnQuery]
  );

  const wrappedTuple = useMemo(
    () => {
      const data: IData = {
        id: tuple.data?.apiFile?.id ?? '',
        fileName: tuple.data?.apiFile?.fileName ?? '',
        url: tuple.data?.apiFile?.url ?? '',
        sizeBytes: tuple.data?.apiFile?.formattedFileSize ?? '',
        mimeType: tuple.data?.apiFile?.mimeType ?? ''
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );

  return [
    fnWrappedQuery,
    wrappedTuple
  ] as const;
}
